<app-navbar></app-navbar>

<div *ngIf="loading" class="loader-box">
  <div class="loader"></div>
</div>

<div class="page-content">
  <div *ngIf="showTopics" class="card-deck">
    <div class="card topic-card" (click)="navigateTo('sermons-and-videos')">
      <div class="card-body">
        <h5 class="text-center ">SERMONS & VIDEOS</h5>
      </div>
    </div>
    <div class="card topic-card" (click)="navigateTo('blog-posts')">
      <div class="card-body">
        <h5 class="text-center">BLOG POSTS</h5>
      </div>
    </div>
    <div class="card topic-card" (click)="navigateTo('gallery')">
      <div class="card-body">
        <h5 class="text-center">GALLERY</h5>
      </div>
    </div>
  </div>


  <div *ngIf="!showTopics" class="topic-content">
    <button class="btn btn-sm btn-light ml-4" (click)="showTopics=true; navigateTo('')">
      <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
    </button>
    <h2 class="text-center mb-4 title">{{title}}</h2>

    <div class="media-content">
      <div *ngIf="title == 'SERMONS AND VIDEOS'">
        <videos></videos>
      </div>
      <div *ngIf="title == 'BLOG POSTS'">
        <blogs></blogs>
      </div>
      <div *ngIf="title == 'GALLERY'">
        <gallery></gallery>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
